import { LazyLoad } from 'app/utils';

export const ShopSortPage = LazyLoad(() => import('./index'), (module) => module.ShopSortPage);
